import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import ContactButton from './home/contactButton'
import xuantiFuzeren from '../images/home/xuanti-fuzeren.png'
import gaojian from '../images/home/gaojian-xiangguancaifang.png'
import jiangbei from '../images/home/jiangbei.png'
import caifang from '../images/home/caifang-renyuan.png'
import { Button, Form, Input, Select, Typography, message } from 'antd'
import { useParams } from 'react-router-dom'
import { getDownFile, applicationAdd, BASE_URL, getAwardsList } from '../api/api'
import useMediaQuery from '../hooks/useMediaQuery'

const { Item } = Form
const { TextArea } = Input

const Sqb = () => {
  const { name: paramValue = '' } = useParams()

  // 获取特定参数的值
  const [index, setIndex] = useState(Number(paramValue) || 0)
  const [file, setFile] = useState('')
  const [data, setData] = useState([])

  useEffect(() => {
    getAwardsList().then(res => {
      console.log(res)
      const arr = res?.data?.map(({ id, name }) => {
        return { label: name, value: id }
      })
      setData(arr || [])
    })
    getDownFile().then(res => {
      setFile(res.data)
    })
  }, [])

  const list = [
    { name: '代表报名', img: caifang },
    { name: '媒体报名', img: gaojian },
    { name: '嘉宾报名', img: xuantiFuzeren },
    { name: '奖项申报', img: jiangbei }
  ]

  const onClick = key => () => setIndex(key)

  const formList = [
    { name: 'username', label: '您的姓名', message: '请输入您的姓名' },
    { name: 'wechat', label: '微信', message: '请输入微信' },
    { name: 'mobile', label: '手机', message: '请输入手机' },
    { name: 'email', label: '邮箱', message: '请输入邮箱' },
    { name: 'company', label: '单位名称', message: '请输入单位名称' },
    { name: 'tel', label: '电话', message: '请输入电话' }
  ]

  const onSubmit = values => {
    // index/applicationAdd
    const params = new URLSearchParams({
      ...values,
      type: index + 1,
      awards_ids: values.awards_ids.toString()
    })
    const queryString = params.toString()
    applicationAdd(`index/applicationAdd?${queryString}`.replace('.html', '')).then(res => {
      message.open({
        type: res?.code === 1 ? 'success' : 'error',
        content: res?.msg
      })
    })
  }

  const isMobile = useMediaQuery()

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0" name={list[index].name}>
        <div className="flex flex-col lg:flex-row">
          <div className="gap-4 flex lg:flex-col lg:w-[236px] flex-wrap lg:flex-nowrap">
            {list.map(({ name, img }, key) => (
              <ContactButton
                key={key}
                onClick={onClick(key)}
                className={`${key === index ? 'bg-[#0189D5]' : 'bg-[#00CCFF]'} p-2 lg:p-0`}
                name={name}
                icon={img}
                url={`/sqb/name/${key}`}
              />
            ))}
          </div>
          <div className="lg:ml-[70px] w-auto mt-10 lg:mt-0 mb-10 lg:mb-0">
            <Form onFinish={onSubmit} className="sqb-form">
              {index === 3 ? (
                <Item
                  name="awards_ids"
                  label="奖项名称"
                  rules={[{ required: true, message: '请选择奖项名称' }]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '324px' }}
                    placeholder="奖项名称"
                    // onChange={handleChange}
                    options={data}
                  />
                  <span className="text-[#FF0000] ml-4">*</span>
                </Item>
              ) : null}
              {formList.map(({ name, label, message }, key) => (
                <Item
                  key={key}
                  name={name}
                  label={label}
                  rules={[{ required: true, message: message }]}
                >
                  <div className="flex items-center">
                    <Input className="h-[38px] w-[324px]" />
                    <span className="text-[#FF0000] ml-4">*</span>
                  </div>
                </Item>
              ))}
              <Item name="content" label="内容" rules={[{ required: true, message: '请输入内容' }]}>
                <TextArea style={{ width: isMobile ? '100%' : 546, height: 154 }} />
              </Item>
              <div className="lg:ml-20 mt-[34px] flex flex-col lg:flex-row items-start lg:items-center">
                <Button className="bg-[#0189D5] text-white font-alhpr" htmlType="submit">
                  确定提交
                </Button>
                <a
                  download
                  target="_blank"
                  className="text-[#0189D5] mt-4 lg:mt-0 lg:ml-6"
                  href={`${BASE_URL}${file}`}
                  rel="noreferrer"
                >
                  奖项资料下载
                </a>
                <Typography className="text-[#FF0000] mt-4 lg:mt-0 lg:ml-6">
                  带有*号为必填项，请认真填写
                </Typography>
              </div>
            </Form>
          </div>
        </div>
      </Subpages>
    </Layout>
  )
}

export default Sqb
